import * as React from 'react'

import {Form, message, Tabs} from 'antd';
import {FormComponentProps} from "antd/lib/form";
import {observer} from "mobx-react";
import {ViewBaseComponent} from "../../../src/views/ViewComponentBase";
import KixGbcMemberLayout from "../../layouts/KixGbcMemberLayout/KixGbcMemberLayout";
import commonStyles from '../../../src/styles/common.scss';
// kix-gbc Web用のAPIパス（セッション認証）
const KIX_GBC_API_PATH = "/api/kix_gbc";
import {loginUserStore} from "../../store/Login/LoginUserStore";
import appStyles from '../../assets/css/app.scss';
import {observable, runInAction} from "mobx";
import portableFetch from "portable-fetch";
import {CouponTabsStore} from "../../../src/store/views/CouponTabs/CouponTabsStore";
import {CouponsStore} from "../../../src/store/views/Coupons/CouponsStore";
import {Link} from "react-router-dom";

// const FormItem = Form.Item;

@observer
class Coupons extends ViewBaseComponent<{} & FormComponentProps, {}> {
  formUtils = this.props.form;

  couponsStore: CouponsStore;
  couponTabsStore: CouponTabsStore;

  @observable
  remaining = 0;

  @observable
  isModalVisible = false;

  @observable
  accountInfo: any = {};

  componentWillMount() {
    this.couponsStore = new CouponsStore();
    this.couponsStore.getList();

    this.couponTabsStore = new CouponTabsStore();
    this.couponTabsStore.getList();

    loginUserStore.getLoginUser().then(() => {
      let bodyObj = {};
      const method = "POST";
      const body = JSON.stringify(bodyObj);
      const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      };
      portableFetch(KIX_GBC_API_PATH + "/check_account_condition", {
        method,
        headers,
        body,
        credentials: "include"
      }).then(async (res: any) => {
        const json = await res.json();
        runInAction(() => {
          if (json.result.code == 1) {
            this.accountInfo = json.value;
          } else {
            message.error(json.result.message);
          }
        });
      }).catch((_e: any) => {
        message.error("通信に失敗しました。画面を更新して下さい。");
      });
    });
  }

  componentWillUnmount() {
  }

  tabChange() {
  }

  render() {
    return (
      <><KixGbcMemberLayout>
        <h2 className={appStyles.h2blue} style={{marginTop: "2em", marginBottom: "2em"}}>クーポン</h2>

        <Tabs onChange={this.tabChange} type="card">
          <Tabs.TabPane tab={"全て"} key={0}>
            <div className={`${commonStyles.f} ${commonStyles.fWrap}`}>
              {this.couponsStore.list
                .map((coupons) => {
                  return (
                    <div className={`${commonStyles.fCenter}`} key={coupons.coupons!.id} style={{width: "45%"}}>
                      <Link to={`/coupons/detail/${coupons.coupons!.id}`}>
                        <img src={coupons.coupons!.thumbnail_url} style={{maxHeight: "300px"}}/>
                      </Link>
                    </div>
                  );
                })}
            </div>
          </Tabs.TabPane>
          {this.couponTabsStore.list.map((value) => {
            return (
              <Tabs.TabPane tab={value.coupon_tabs!.title} key={value.coupon_tabs!.id}>
                <div className={`${commonStyles.f} ${commonStyles.fWrap}`}>
                  {this.couponsStore.list
                    .filter(v => v.coupons!.coupon_tab_id == value.coupon_tabs!.id)
                    .map((coupons) => {
                      return (
                        <div className={`${commonStyles.fCenter}`} key={coupons.coupons!.id} style={{width: "45%"}}>
                          <Link to={`/coupons/detail/${coupons.coupons!.id}`}>
                            <img src={coupons.coupons!.thumbnail_url} style={{maxHeight: "300px"}}/>
                          </Link>
                        </div>
                      );
                    })}
                </div>
              </Tabs.TabPane>
            )
          })}
        </Tabs>


      </KixGbcMemberLayout>
      </>
    );
  }
}

export default Form.create()(Coupons)

